<template>
  <div
    :class="['btn-modal', size, { disable: disable, btn: !disable }]"
    @click="onClick"
  >
    <div v-html="btnInner"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "btnModal",
  props: {
    btnInner: {
      type: String,
      default: "",
    },
    disable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      validator(val) {
        return ["small", "large", "middle"].includes(val);
      },
      default: "middle",
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-modal {
  position: relative;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}
.disable {
  @extend .btn;
  // pointer-events: none;
  filter: grayscale(1);

  &:active {
    animation: none;
  }
}
.btn {
  display: inline-block;
  padding: 0 0.2rem;
  text-align: center;
  background-size: 100% 100% !important;
  color: #fff;
  white-space: nowrap;
}

.small {
  @include bgImg("root/btn-harvest.png");
  min-width: 1.3rem;
  min-height: 0.48rem;
  padding: 0 0.1rem;
  font-size: 0.24rem;
}

.middle {
  @include bgImg("modal/modal-confirm.png");
  @extend .text-shadow;
  min-width: 2.75rem;
  min-height: 1.01rem;
  padding: 0 0.2rem;
  font-size: 0.38rem;
}

.large {
  @include bgImg("root/btn-style_1.png");
  min-width: 4.02rem;
  min-height: 1.47rem;
  margin: 0 auto;
  padding: 0 1rem 0.3rem;
  font-size: 0.56rem;
  font-weight: 600;
  text-shadow: 0 -2px 0 $text-color_2, 2px 0 0 $text-color_2,
    0px 2px 0 $text-color_2, -2px 0 0 $text-color_2;
}
</style>